import styled from 'styled-components/macro';

export const List = styled.ul`
    font-size: 1.5rem;
`